import Grid from "@mui/material/Grid2";
import {
  Button,
  Dialog,
  DialogTitle,
  Paper,
  Typography,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import FmeRecordsTable from "./FmeRecordsTable";
import { useSelector } from 'react-redux';
import { formatDateToDDMMYYYY, formatNumber } from '../../../../../utils/helpers';
import { ReceiptStatus } from '../ReceiptsTable/ReceiptStatus';

interface FmeRecordsReceiptProps {
  open: boolean;
  handleClose: () => void;
}

const FmeRecordsReceiptModal = ({ open, handleClose }: FmeRecordsReceiptProps) => {
  const { selectedReceipt } = useSelector((state: any) => state.receipts);

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{ sx: { width: "900px", maxWidth: "900px" } }}
      >
        <Paper sx={{ padding: "16px 24px 20px 24px" }}>
          <DialogTitle sx={{ padding: "0px 0px 16px 0px" }}>
            FME Records connected to this receipt
          </DialogTitle>
          <Grid container mt={0} columnSpacing={2}>
            <Grid size={12}>
              <Box
                className="fmeRecordsWrap"
                display={"flex"}
                alignItems={"flex-start"}
              >
                <Stack>
                  <span>Company</span>
                  <Typography>{selectedReceipt?.finance_company_name || ""}</Typography>
                </Stack>
                <Stack>
                  <span>Date</span>
                  <Typography>{formatDateToDDMMYYYY(selectedReceipt?.receipt_date) || ""}</Typography>
                </Stack>
                <Stack>
                  <span>Receipt Number</span>
                  <Typography>{selectedReceipt?.receipt_id || ""}</Typography>
                </Stack>
                <Stack>
                  <span>Receipt Amount</span>
                  <Box display={"flex"} alignItems={"center"}>
                    <Typography>{formatNumber(selectedReceipt?.receipt_amount || "")}</Typography>
                    <Stack
                      sx={{
                        color: "rgba(0, 0, 0, 0.56)",
                        fontSize: "18px !important",
                        fontWeight: "500",
                        ml: 0.5
                      }}
                    >
                      {selectedReceipt?.receipt_currency_symbol || ""}
                    </Stack>
                  </Box>
                </Stack>
                <Stack>
                  <span>Receipt Status</span>
                  <Box>
                    <ReceiptStatus status={selectedReceipt?.receipt_status} />
                  </Box>
                </Stack>
              </Box>
            </Grid>
          </Grid>
          <FmeRecordsTable />
          <Stack flexDirection={"row"} justifyContent={"end"} marginTop={2}>
            <Button color="secondary" variant="outlined" onClick={handleClose}>
              CANCEL
            </Button>
          </Stack>
        </Paper>
      </Dialog>
    </>
  );
};

export default FmeRecordsReceiptModal;
